import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfirmationSimpleComponent } from '@lib/components/confirmation-simple/confirmation-simple.component';
import { OuiDialogService } from 'omnium-ui/dialog';
import { AdminConfigService } from 'src/app/services/admin-config.service';

@Component({
  selector: 'app-activate-conseil-config',
  templateUrl: './activate-conseil-config.component.html',
  styleUrls: ['./activate-conseil-config.component.scss'],
})
export class ActivateConseilConfigComponent {
  @Input({ required: true }) configId: string;

  @Output() onActivateConfig = new EventEmitter<string>();

  constructor(private adminConfigService: AdminConfigService, private dialogService: OuiDialogService) {}

  isLoading = false;
  async onActivate(): Promise<void> {
    const confirmRef = this.dialogService.openDialog(
      ConfirmationSimpleComponent,
      {
        title: 'Passer en actif',
        message:
          'Vous êtes sur le point de rendre actif un template. Le template actuellement actif sera automatiquement archivé.',
        validateButtonLabel: 'Valider',
        cancelButtonLabel: 'Annuler',
      },
      'auto',
      '364px'
    );

    const confirmed = await confirmRef.afterClosed().toPromise();
    if (confirmed) {
      this.isLoading = true;
      try {
        const result = await this.adminConfigService.activateDraftConseilConfig(this.configId);
        if (result?.id) {
          this.onActivateConfig.emit(this.configId);
        }
      } finally {
        this.isLoading = false;
      }
    }
  }
}
